import { Input as InputComponent } from '@components-deprecated'

import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface OrganizationCVRDataProps {
  visible?: boolean
}

export const OrganizationCVRData = styled.div<OrganizationCVRDataProps>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  margin-top: ${Spacing.S16};
`

export const Input = styled(InputComponent)`
  margin-bottom: ${Spacing.S8};
`

export const DualInputsWrapper = styled.div`
  display: flex;

  ${() => Input} {
    width: 50%;
    margin-right: ${Spacing.S8};
    margin-bottom: 0;

    &:last-of-type {
      margin-right: 0;
    }
  }
`
